import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import CardActualizacionMasiva from "../../../General/Excel/CardActualizacionMasiva";
import {
    postMasivaImagenesExcelApi
} from '../../../../api/axios';
import { toast } from '../../../../utilities/appToast';
import { formatFile } from '../../../../utilities/formatFile';
import PropTypes from 'prop-types';

export default function CargaMasivaImagenesExcel({ idSeller, userType, idUsuario }) {
    const [file, setFile] = useState();
    const [isLoading, setIsLoading] = useState(false);

    const isValidUpdateExcel = () => {
        if (!file) {
            toast.warn('No se ha seleccionado ningún archivo CSV');
            return false;
        }
        return true;
    }


    const exportExcel = async () => {
        setIsLoading(true);

        const fileName = String(file.name ?? '').toLowerCase();
        let excelBase64;
        if (fileName.endsWith('.csv')) {
            const text = await file.text();
            const wb = XLSX.read(text, { type: 'string', raw: true });
            excelBase64 = XLSX.write(wb, { bookType: 'xlsx', type: 'base64' });
        } else {
            excelBase64 = await formatFile(file, 'xlsx');
        }
        let response = postMasivaImagenesExcelApi({ file: excelBase64 });

        response.then(res => {
            toast.success("Las publicaciones se actualizaron correctamente.")
        }).catch(err => {
            (err.response.data.errores)
                ? err.response.data.errores.forEach(error => toast.warn(error))
                : toast.error("Las publicaciones no pudieron ser actualizadas");
        }).finally(() => {
            setIsLoading(false);
        });
    }

    return (
        <div className="card p-4">
            <CardActualizacionMasiva
                title="Carga Masiva Imágenes"
                btnText="Actualizar Imágenes"
                updateFile={setFile}
                isLoading={isLoading}
                exportExcel={exportExcel}
                isValidUpdateExcel={isValidUpdateExcel}
                tipoExcel={2}
                downloadName="Modelo Actualización Masiva Imágenes"
            >
                
            </CardActualizacionMasiva>
        </div>
    );
}
CargaMasivaImagenesExcel.propTypes = {
    idSeller: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    userType: PropTypes.object,
    idUsuario: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}